import { render, staticRenderFns } from "./new-table.vue?vue&type=template&id=06d5708f&scoped=true"
import script from "./new-table.vue?vue&type=script&lang=js"
export * from "./new-table.vue?vue&type=script&lang=js"
import style0 from "./new-table.vue?vue&type=style&index=0&id=06d5708f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d5708f",
  null
  
)

export default component.exports